module.exports = __webpack_public_path__ + "img/siteNum.cde43369.png";